import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

const PARAMS = new HttpParams();

@Injectable({
  providedIn: 'root'
})
export class TypeaheadService {

  constructor(private http: HttpClient) { }

  search(term: string, URL: string) {
    if (term === '') {
      return of([]);
    }

    return this.http
      .get(URL, { params: PARAMS.set('term', term) }).pipe(
        map(response => response)
      );
  }
}
